import { Chip, ChipProps } from "@mui/material"
import { AuthorType } from "interface/article"

type AuthorTypeChipProps = {
	authorType?: number
} & ChipProps
export const AuthorTypeChip = ({
	authorType,
	...others
}: AuthorTypeChipProps) => {
	return (
		authorType === AuthorType.FirstAuthor ? (
			<Chip
				component="span"
				size="small"
				variant="filled"
				label="先頭"
				color="primary"
				{...others}
			/>
		) : authorType === AuthorType.LastAuthor ? (
			<Chip
				component="span"
				size="small"
				variant="filled"
				label="責任"
				color="secondary"
				{...others}
			/>
		) : authorType === AuthorType.SingleAuthor ? (
			<Chip
				component="span"
				size="small"
				variant="filled"
				label="単独"
				color="success"
				{...others}
			/>
		) : (
			<></>
		)
	)
}